import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Sparkles, ArrowLeft, Search } from "lucide-react";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="not-found-page">
      <div className="text-center max-w-md animate-fade-in-up">
        {/* Illustration */}
        <div className="relative w-32 h-32 mx-auto mb-8">
          <div className="absolute inset-0 bg-cyan-500/15 rounded-full animate-pulse opacity-50" />
          <div className="absolute inset-2 bg-gradient-to-br from-cyan-500/10 to-violet-500/10 rounded-full flex items-center justify-center">
            <Search className="w-12 h-12 text-cyan-300" />
          </div>
          <div className="absolute -top-1 -right-1 w-8 h-8 bg-pink-500/15 rounded-full flex items-center justify-center">
            <span className="text-pink-400 text-xs font-bold">?</span>
          </div>
        </div>

        <h1 className="font-outfit text-6xl font-bold text-gradient mb-2">404</h1>
        <h2 className="font-outfit text-xl font-medium text-foreground mb-2">Page Not Found</h2>
        <p className="text-sm text-muted-foreground mb-8 leading-relaxed">
          This assistant or page doesn't exist. It may have been moved or the URL might be incorrect.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            data-testid="404-home-btn"
            onClick={() => navigate("/")}
            className="bg-gradient-to-r from-cyan-400 to-violet-500 text-white rounded-lg px-6 shadow-glow-sm hover:-translate-y-0.5 transition-all press-down"
          >
            <Sparkles className="w-4 h-4 mr-2" /> Go Home
          </Button>
          <Button
            data-testid="404-back-btn"
            onClick={() => navigate(-1)}
            variant="outline"
            className="border-border text-foreground/80 hover:bg-white/5 rounded-lg bg-card press-down"
          >
            <ArrowLeft className="w-4 h-4 mr-2" /> Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
